const instrumentExtendEditableFields = [
    "projectId",
    "pointIdx",
    "nickname",
    "lowerScale",
    "upperScale",
    "statusStaticNote",
    "hidden",
    "longtitude",
    "latitude",
    "height",
    "depthSeriesConfigId"
];

export const cloneInstrumentExtends = items => (items ?? []).map(item => ({ ...item }));

const normalizeOptionalText = value => {
    const text = String(value ?? "").trim();
    return text === "" ? null : text;
};

const normalizeOptionalNumber = (value, label) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const number = Number(value);
    if (!Number.isFinite(number)) {
        throw new Error(`${label}必須是有效數字。`);
    }
    return number;
};

export const toInstrumentExtendPayload = (row, isNew) => {
    const pointIdx = Number(row.pointIdx);
    if (!Number.isInteger(pointIdx) || pointIdx < 0) {
        throw new Error("點號必須是大於或等於 0 的整數。");
    }

    const payload = {
        projectId: row.projectId,
        pointIdx,
        nickname: normalizeOptionalText(row.nickname),
        lowerScale: normalizeOptionalNumber(row.lowerScale, "下限"),
        upperScale: normalizeOptionalNumber(row.upperScale, "上限"),
        statusStaticNote: normalizeOptionalText(row.statusStaticNote),
        hidden: Boolean(row.hidden),
        longtitude: normalizeOptionalNumber(row.longtitude, "經度") ?? 0,
        latitude: normalizeOptionalNumber(row.latitude, "緯度") ?? 0,
        height: normalizeOptionalNumber(row.height, "海拔") ?? 0,
        depthSeriesConfigId: normalizeOptionalText(row.depthSeriesConfigId)
    };

    if (!isNew) {
        payload.id = row.id;
    }

    return payload;
};

export const areInstrumentExtendsEqual = (left, right) => {
    if (!left || !right) {
        return false;
    }

    return instrumentExtendEditableFields.every(field => {
        const leftValue = left[field] === "" ? null : left[field];
        const rightValue = right[field] === "" ? null : right[field];
        return String(leftValue ?? "") === String(rightValue ?? "");
    });
};
